import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { Button, Select, Modal, Form } from "@gpstrackit/gtc-react-controls";
import { Checkbox } from 'Components';

import { reset as resetModalExportColumnsPdf, openModalExportColumnPdf, onColumnsToExport } from '../modalExportColumnsPdf/redux/slice';

const MAX_HEADER_SELECTED = 7

const ModalExportColumnsPdf = (props) => {

  const { maxColumns, title, detailMessage } = props;
  const dispatch = useDispatch();
  const { messages } = useIntl();

  const open = useSelector(state => state.fleetModalExportColumnsPdfRedux.open);
  const loading = useSelector(state => state.fleetModalExportColumnsPdfRedux.loading);
  const columnHeaders = useSelector(state => state.fleetModalExportColumnsPdfRedux.columns);
  
  const [selectedColumns, setSelectedColumns] = useState([]);

  useEffect(() => {
    return () => {  
        dispatch(resetModalExportColumnsPdf());
    };
  }, []);
  
  const handleClose = () => {
    dispatch(openModalExportColumnPdf({ open: false }));
  };

  const handleSuccess = () => {
    dispatch(onColumnsToExport({ columnsToExport: selectedColumns }))
  }

  return (
    <Modal
      title={title || messages["exportVehicles_title"]}
      size="small"
      loading={loading}
      open={open}
      handleClose={handleClose}
      footer={
        <div>
          <Button
            variant="secondary"
            style={{ marginRight: "5px" }}
            onClick={() => handleClose()}
            disabled={loading}
          >
            {messages["cancel"]}
          </Button>
          <Button
            variant="primary"
            onClick={(e) => handleSuccess()}
            disabled={loading}
          >
            {messages["export"]}
          </Button>
        </div>
      }
    >
      <div style={{ padding: "12px 25px" }}>
        <p>{ (detailMessage || messages["fleet_export_modal_pdf_message"])?.replace('{{number}}', maxColumns || MAX_HEADER_SELECTED)}</p>
      </div>
      <div style={{ padding: "12px 25px" }}>
        
        {columnHeaders?.filter(m => m.export)?.map((header) => {
            return (
            <div
                key={header.key}
                style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                }}
            >
                <Checkbox 
                key={`check_${header.key}`}
                value={selectedColumns?.find((selected) => selected === header)}
                onChange={() => {
                    const validate = selectedColumns?.find(
                    (selected) => selected === header
                    );
                    if (validate)
                    return setSelectedColumns(
                        selectedColumns.filter((item) => item !== header)
                    );
                    if (selectedColumns?.length === (maxColumns || MAX_HEADER_SELECTED)) return;
                    setSelectedColumns((prevValues) => [...prevValues, header]);
                }}
                />
                <p>{header?.title}</p>
            </div>
            );
        })}
          
      </div>
    </Modal>
  );
};

export default ModalExportColumnsPdf;